import find from 'lodash/find'
import isEqual from 'lodash/isEqual'
import type { FilterQuery } from '@ztechapps/common.contract'
import { PositiveCountOptionEnum } from '@ztechapps/common.hook'

/** The condition stored under the field name; the caller wraps it as `{ [field]: condition }`. */
export const positiveCountOptionToFilter = (option: PositiveCountOptionEnum): FilterQuery<any> =>
  //`$not` also matches a zero, a null and a missing value
  option === PositiveCountOptionEnum.AboveZero ? { $gt: 0 } : { $not: { $gt: 0 } }

export const filterToPositiveCountOption = (filter?: FilterQuery<any>): PositiveCountOptionEnum | undefined =>
  find(Object.values(PositiveCountOptionEnum), (option) => isEqual(filter, positiveCountOptionToFilter(option)))
